import styled from "styled-components";

export const Container = styled.div`
  max-width: 80%;
  overflow-x: hidden;
`;
export const LabelIcon = styled.span`
  margin-top: 2px;
  position: relative;
  margin-left: 8px;
  cursor: pointer;

  &:hover {
    .float-text {
      visibility: visible;
      opacity: 1;
    }
  }
`;
export const FloatText = styled.span`
  position: absolute;
  display: block;
  left: 120%;
  top: -10%;
  width: 232px;
  height: 32px;
  background: #323232;
  border-radius: 8px;
  letter-spacing: -0.01em;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 12px;
  line-height: 130%;
  transition: all 0.3s;
  visibility: hidden;
  opacity: 0;

  .check-icon {
    margin-right: 8px;
  }
`;
